import { createContext } from 'react';

interface ContextProps {
  expandedAll: boolean;
  setExpandedALl: (value: boolean) => void;
}

export const CreativeExpansionContext = createContext<ContextProps>({} as ContextProps);
